import { APIURI } from "config/config"
import { getItem } from '../storage/UserAsyncStorage';
import { getCountry } from "config/config";

export const HttpGet = async (uri, destructure = false) => {
    const userData = await getItem()
    const token = JSON.parse(userData)?.token

    try {
        const headers = !token
            ? {
                "Content-Type": "application/json",
                Country: getCountry()
            }
            : {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                Country: getCountry()
            };

        const data = await fetch(`${APIURI}${uri}`, {
            headers: headers,
        });

        const response = await data.json()

        return response.data;
    } catch (error) {
        console.log(error)
        return errorResponse(error.response);
    }
};

export const HttpGetPaginate = async (uri, destructure = false) => {
    const userData = await getItem()
    const token = JSON.parse(userData)?.token

    try {
        const headers = !token
            ? {
                "Content-Type": "application/json",
                Country: getCountry()
            }
            : {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                Country: getCountry()
            };

        const data = await fetch(`${APIURI}${uri}`, {
            headers: headers,
        });

        const response = await data.json()

        return response;
    } catch (error) {
        console.log(error)
        return errorResponse(error.response);
    }
};

export const HttpDelete = async (uri, destructure = false) => {
    const userData = await getItem()
    const token = JSON.parse(userData)?.token

    try {
        const data = await fetch(`${APIURI}${uri}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                Country: getCountry()
            },
            method: 'DELETE'
        });

        const response = await data.json()

        return response.data;
    } catch (error) {
        console.log(error)
        return errorResponse(error.response);
    }
};

export const HttpPost = async (uri, payload = "", withToken = true, optionalHeaders = {}) => {
    const userData = await getItem();
    const token = JSON.parse(userData)?.token;

    // Detectar si el payload es FormData
    const isFormData = payload instanceof FormData;

    try {
        let headers = {
            Country: getCountry(),
            ...optionalHeaders
        };

        // Si es con Token, agregamos Authorization
        if (withToken) {
            headers["Authorization"] = `Bearer ${token}`;
        }

        // --- EL CAMBIO CLAVE ---
        // Si NO es FormData, le ponemos JSON. 
        // Si ES FormData, dejamos que el navegador ponga el Content-Type solo.
        if (!isFormData && !optionalHeaders["Content-Type"]) {
            headers["Content-Type"] = "application/json";
        }
        
        // Si mandamos undefined/null en optionalHeaders, lo borramos para que no viaje
        if (headers["Content-Type"] === undefined) {
            delete headers["Content-Type"];
        }

        const data = await fetch(`${APIURI}${uri}`, {
            method: "POST",
            body: payload, // fetch detecta que es FormData y lo procesa bien
            headers: headers
        });

        const response = await data.json();
        return response;
    } catch (error) {
        return errorResponse(error);
    }
};

export const HttpPostImage = async (uri, payload = "", withToken = true, optionalHeaders = {}) => {
    const userData = await getItem()
    const token = JSON.parse(userData)?.token

    try {
        const headers = withToken
            ? {

                Authorization: `Bearer ${token}`,
                Country: getCountry()
            }
            : {
                Country: getCountry()
            };

        const data = await fetch(`${APIURI}${uri}`, {
            method: "POST",
            body: payload,
            headers: headers
        });

        const response = await data.json()

        return response;
    } catch (error) {
        return errorResponse(error);
    }
};

export const HttpPut = async (uri, payload = "") => {
    const userData = await getItem()
    const token = JSON.parse(userData)?.token

    try {
        const data = await fetch(`${APIURI}${uri}`, {
            method: "PUT",
            body: payload,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                Country: getCountry()
            },
        })

        const response = await data.json()
        return response;

    } catch (error) {
        return errorResponse(error.response);
    }
};

// export const HttpPatch = async (uri, payload = "", desustructed = false) => {
//     try {
//         const { data } = await axios.patch(`${APIURI}${uri}`, payload, {
//             headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${userData.token}`,
//             },
//         });
//         if (desustructed) {
//             const response = {
//                 ...data.data,
//                 ...{ status_code: data.status_code },
//                 ...{ message: data.message },
//             };
//             return response;
//         } else {
//             return data;
//         }
//     } catch (error) {
//         return errorResponse(error.response);
//     }
// };

// export const HttpDelete = async (uri, desustructed = false) => {
//     try {
//         const { data } = await axios.delete(`${APIURI}${uri}`, {
//             headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${userData.token}`,
//             },
//         });

//         if (desustructed) {
//             const response = {
//                 ...data.data,
//                 ...{ status_code: data.status_code },
//                 ...{ message: data.message },
//             };
//             return response;
//         } else {
//             return data;
//         }
//     } catch (error) {
//         return errorResponse(error.response);
//     }
// };

const errorResponse = (message) => {
    return {
        data: [],
        status: 404,
        message: `Error en la conexión con el servidor : ${message}`,
        error: true,
    };
};

